import React from 'react'
import CoreButton from '../CoreButton'
import { useTheme } from '../ThemeProvider/ThemeProvider'
import styles from './ErrorFallback.module.scss'

const FEATURE_LABELS = {
  editor: 'the Editor',
  breakdown: 'Script Breakdown',
  scheduling: 'Scheduling',
  budgeting: 'Budgeting',
  shotList: 'the Shot List',
  aiVideo: 'the AI Video editor',
  storyboard: 'the Storyboard',
  pitchDeck: 'the Pitch Deck',
  plotHole: 'the Plot Hole report',
  scriptCoverage: 'Script Coverage',
  tableRead: 'Table Read',
  scriptDoctor: 'Script Doctor',
  projectCreation: 'project creation',
  project: 'this project'
}

// eslint-disable-next-line no-undef
const reloadPage = () => window.location.reload()

// Shown in place of a crashed or failed screen, so the user never faces a
// blank page.
const ErrorFallback = ({ feature, title, onRetry = reloadPage, retryLabel = 'Reload' }) => {
  const { themeMode } = useTheme()
  const where = FEATURE_LABELS[feature]
  return (
    <div role='alert' className={`${styles.container} ${styles[themeMode] || ''}`}>
      <p className={styles.title}>
        {title || `Something went wrong${where ? ` in ${where}` : ''}.`}
      </p>
      <CoreButton size='small' mode='contained' onClick={onRetry}>{retryLabel}</CoreButton>
    </div>
  )
}

export default ErrorFallback
